import CloseIcon from '@mui/icons-material/Close';
import CollectionsIcon from '@mui/icons-material/Collections';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import MinimizeIcon from '@mui/icons-material/Minimize';
import { Box, Button, ButtonGroup, Chip, IconButton, Modal, Typography } from "@mui/material";
import "../CSS/Landing.css";
import "../CSS/Layout.css";

import { useMemo, useState } from "react";
import { NEWS_CATEGORY, NEWS_MAX_AMOUNT, newsList } from "../Configurations/NewsList";
import { publicSites } from "../utils/GlobalContext";
import { getCopyRight } from "../utils/tools";

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useNavigate } from 'react-router-dom';
import { LandingPics } from '../Configurations/LandingPicList';



export default function LandingPage() {
  const [newsCategory, setNewsCategory] = useState("all");
  const [newsImages, setNewsImages] = useState("");

  let redirectPath = useNavigate();

  const bannerBar = () => {
    return (<Box className="landing-cover">
      <Box className="cover-text">
        <Typography fontSize={60} fontWeight="bold">Xu Lab</Typography>
        <Typography fontSize={30} fontWeight={100}>Focus on Materials Physical Chemistry</Typography>
        <Box className="navi-bar">
          <Button sx={{ minWidth: "12rem", fontSize: "1.05rem", fontWeight: 400 }}
            variant="contained"
            color="primary"
            onClick={() => redirectPath(publicSites.RESEARCH_AREA.path)}
          >
            Research Area
          </Button>
          <Button sx={{ minWidth: "12rem", fontSize: "1.05rem", fontWeight: 400 }}
            variant="contained"
            color="primary"
            onClick={() => redirectPath(publicSites.DR_XU.path)}
          >
            Dr. Xu
          </Button>
          <Button sx={{ minWidth: "12rem", fontSize: "1.05rem", fontWeight: 400 }}
            variant="contained"
            color="primary"
            onClick={() => redirectPath(publicSites.PEOPLE.path)}
          >
            People
          </Button>
          <Button sx={{ minWidth: "12rem", fontSize: "1.05rem", fontWeight: 400 }}
            variant="contained"
            color="primary"
            onClick={() => redirectPath(publicSites.PUBLICATIONS.path)}
          >
            Publications
          </Button>
          <Button sx={{ minWidth: "12rem", fontSize: "1.05rem", fontWeight: 400 }}
            variant="contained"
            color="primary"
            onClick={() => redirectPath(publicSites.EQUIPMENT.path)}
          >
            Equipment
          </Button>
          <Button sx={{ minWidth: "12rem", fontSize: "1.05rem", fontWeight: 400 }}
            variant="contained"
            color="primary"
            onClick={() => redirectPath(publicSites.RESOURCES.path)}
          >
            Resources
          </Button>
        </Box>
      </Box>
    </Box>);
  };

  const newsSection = useMemo(() => {
    const order = [];
    for (var i = 0; i < newsList.length; i++) {
      let newsDate = new Date(newsList[i].date);
      let orderDate = newsDate.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
      switch (newsCategory) {
        case NEWS_CATEGORY.LAB:
        case NEWS_CATEGORY.OUTREACH:
          if (newsList[i].category === newsCategory)
            order.push([orderDate, i, newsDate.toLocaleDateString(navigator.language)]);
          break;
        default:
          order.push([orderDate, i, newsDate.toLocaleDateString(navigator.language)]);
      }
    }

    if (order.length === 0) {
      return <Typography color="secondary">No Content Yet.</Typography>
    }
    // Sort order: date first and then the order in the config list
    order.sort((a, b) => a[0] > b[0] || a[1] < b[1] ? -1 : 1);
    const content = [];
    for (i = 0; i < Math.min(order.length, NEWS_MAX_AMOUNT); i++) {
      let dateStr = order[i][2]
      let news = newsList[order[i][1]];

      content.push(<Box key={2 * i}>
        {
          news.new ?
            <Chip label={dateStr} size="small" color="secondary" variant="outlined" className='news-chip'
              icon={<FiberNewIcon color="primary" />}
            />
            :
            <Chip label={dateStr} size="small" color="secondary" variant="outlined" className='news-chip' />
        }
      </Box>);
      content.push(
        <Typography key={2 * i + 1} fontWeight={200} component="p" color={"secondary"} fontSize="1.1rem">
          {news.title}
          {
            news.images && <IconButton
              color='secondary'
              size='small'
              value={JSON.stringify(news.images)}
              onClick={(e) => setNewsImages(e.currentTarget.value)}
            >
              <CollectionsIcon fontSize="inherit" />
            </IconButton>
          }
        </Typography>
      );
    }
    return (<Box className="news-section">
      {content}
    </Box>);
  }, [newsCategory]);

  const carouselResponsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    }
  };

  const CustomDot = ({ onClick, active, ...rest }) => {
    return (
      <li
        onClick={() => onClick()}
      >
        {active ? <MinimizeIcon color='primary' />
          : <MinimizeIcon color='grey' />
        }
      </li>
    );
  };

  const pictureCarousel = () => {
    const pictures = [];
    for (var i = 0; i < LandingPics.length; i++) {
      pictures.push(<Box className='single-picture' key={i}>
        <img
          className='single-picture'
          component="img"
          rel="noreferrer"
          src={LandingPics[i].img}
          alt={LandingPics[i].img}
        />
        <Box className="landing-pic-title">
          <Typography color="var(--app-grey)">{LandingPics[i].description}</Typography>
        </Box>
      </Box>)
    }
    return <Carousel
      draggable={false}
      showDots
      responsive={carouselResponsive}
      infinite
      autoPlay
      centerMode={false}
      autoPlaySpeed={5000}
      keyBoardControl={false}
      transitionDuration={500}
      removeArrowOnDeviceType={["tablet", "mobile"]}
      // deviceType={isMobileTablet() ? "mobile" : "desktop"}
      itemClass="single-picture"
      containerClass="single-picture"
      renderButtonGroupOutside={false}
      renderDotsOutside={false}
      customDot={<CustomDot />}
    >
      {pictures}
    </Carousel>
  };

  const NewsImageSection = useMemo(() => {
    if (!newsImages) {
      return <></>;
    }
    let images = [];
    let imgObj = JSON.parse(newsImages)
    for (var i = 0; i < imgObj.length; i++) {
      images.push(<img key={i}
        className='news-image'
        component="img"
        src={imgObj[i]}
        rel="noreferrer"
        alt={imgObj[i]}
      />);
    }
    return images;
  }, [newsImages]);

  return (<>
    {bannerBar()}
    <Box className="content-body">
      <Box className="lab-description-wrapper">
        <Typography className="lab-description" fontSize="1.3rem" fontWeight={200}>
          <p>
            Xu Lab encompasses interdisciplinary research spanning chemistry, physics, and engineering. Utilizing advanced microscopy and spectroscopy, we study atomic-level chemical reactions at surfaces and interfaces, while also synthesizing and characterizing nano-materials. Our research is dedicated to unraveling fundamental steps in heterogeneous reactions and engineering nanostructures on functional material surfaces. The overarching goal of our fundamental science is to provide valuable insights addressing issues in environmental concerns, energy applications, and nanofabrication.
          </p>
          <p>
            We warmly welcome motivated students to join our team. If you are a student with strong hands-on skills, a passion for conducting experiments, or an interest in visualizing scientific concepts through images, we encourage you to send your resume and unofficial transcript (if applicable) to fang.xu@utsa.edu.
          </p>
        </Typography>
      </Box>
      <Box className="landing-middle-section">
        <Box className="flex-column-left" sx={{ gap: "1rem", maxWidth: "50rem" }}>
          <ButtonGroup color="secondary" size="small">
            <Button key="all" onClick={() => setNewsCategory("all")}>All</Button>
            <Button key="news" onClick={() => setNewsCategory(NEWS_CATEGORY.LAB)}>Lab News</Button>
            <Button key="outreach"
              onClick={() => setNewsCategory(NEWS_CATEGORY.OUTREACH)}
            >
              Outreaches
            </Button>
          </ButtonGroup>
          {newsSection}
        </Box>
        <Box mt={"2.5rem"}>
          {pictureCarousel()}
        </Box>
      </Box>
    </Box>

    <Box className="flex-row">
      <Typography fontSize={"1rem"} color={"grey"} mt="2rem">
        {getCopyRight()}
      </Typography>
    </Box>
    <Modal
      open={newsImages !== undefined && newsImages !== ""}
      onClose={() => setNewsImages("")}
    >
      <Box className="news-modal">
        <Box className="news-image-list">
          {NewsImageSection}
          <IconButton
            sx={{ position: "absolute", top: "0rem", right: "0rem" }}
            color="primary"
            onClick={() => setNewsImages("")}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
    </Modal>
  </>);
}